import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-lang-redirector',
  templateUrl: './lang-redirector.component.html',
  styleUrls: ['./lang-redirector.component.scss'],
})
export class LangRedirectorComponent implements OnInit {
  // todo remove it (just for debug lang redirecting)
  constructor(private router: Router, private route: ActivatedRoute) {
    // eslint-disable-next-line no-console
    console.warn('LangRedirector called:', this.router.url);
  }

  ngOnInit(): void {}
}
